<div class="w-full flex flex-col gap-16 md:gap-28">
  <!-- Sección de la cabecera. -->
  <section class="mt-16 md:mt-28 flex flex-col gap-4">
    <h1 class="text-4xl font-medium md:text-5xl">Contraseña y seguridad</h1>
    <p class="text-lg md:text-xl">
      Refuerza la seguridad de tu cuenta con una nueva contraseña.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="w-full xl:w-2/4">
    <form
      class="flex flex-col"
      [formGroup]="form"
      (ngSubmit)="updatePassword()"
    >
      <mat-form-field>
        <mat-label>Contraseña actual</mat-label>
        <input
          matInput
          [type]="currentPasswordHide ? 'password' : 'text'"
          name="currentPassword"
          formControlName="currentPassword"
        />
        @if (formCurrentPassword?.value) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="currentPasswordHide = !currentPasswordHide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="currentPasswordHide"
        >
          <mat-icon>{{
            currentPasswordHide ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Contraseña nueva</mat-label>
        <input
          matInput
          [type]="newPasswordHide ? 'password' : 'text'"
          name="newPassword"
          formControlName="newPassword"
        />
        @if (formNewPassword?.value) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="newPasswordHide = !newPasswordHide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="newPasswordHide"
        >
          <mat-icon>{{
            newPasswordHide ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
        }
        <mat-hint class="text-gray-500"
          >Minúsculas, mayúsculas, números, caracteres especiales y mínimo ocho
          caracteres.</mat-hint
        >
      </mat-form-field>
      <mat-form-field>
        <mat-label>Repetir contraseña nueva</mat-label>
        <input
          matInput
          [type]="confirmNewPasswordHide ? 'password' : 'text'"
          name="confirmNewPassword"
          formControlName="confirmNewPassword"
        />
        @if (formConfirmNewPassword?.value) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="confirmNewPasswordHide = !confirmNewPasswordHide"
          [attr.aria-label]="'Hide password'"
          [attr.aria-pressed]="confirmNewPasswordHide"
        >
          <mat-icon>{{
            confirmNewPasswordHide ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
        }
      </mat-form-field>

      <!-- Errores -->
      @if (errors) {
      <div class="flex flex-col gap-2 text-center lg:text-start mt-5">
        @for (error of errors; track error) {
        <span class="text-sm text-red-500">{{ error }}</span>
        }
      </div>
      }

      <button
        type="submit"
        mat-flat-button
        class="lg:w-64 mt-10"
        [disabled]="form.invalid || loading"
      >
        @if (loading) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Cambiar contraseña</span>
        }
      </button>
    </form>
  </section>
</div>
